import { defineMessages } from "@/i18n";
import en from "./en";

export const desktopShellMessages = defineMessages("desktop-shell", en);
